import { render, staticRenderFns } from "./_sulifu.vue?vue&type=template&id=f4019b58&lang=pug&"
import script from "./_sulifu.vue?vue&type=script&lang=js&"
export * from "./_sulifu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports